const config = {
  // API_URL: 'https://dc2d-103-81-77-181.ngrok-free.app/',
  API_URL: 'https://devapi.rabbetgaming.com', 
  // API_URL: 'https://prodapi.rabbetgaming.com',
  // API_URL: 'http://localhost:3000',
};

export default config;
   